import { Name as EntityName } from '../../entity';

export const TYPE = `${EntityName.ACTION_PREFIX}FORM:send_form`;

export interface Payload {
    p: string; // project id
    f: string; // f id
}
